var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-5"},[_c('CogCalculatorForm',{staticClass:"px-3",attrs:{"msgs":_vm.msgs}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-5 pt-5"},[_c('DensityAltitudeCalculatorForm',{staticClass:"px-3",attrs:{"msgs":_vm.msgs}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }